function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .action-opps-global-giving_svg__action-opps-global-giving_svg__st0{fill:#EF8A1D}.action-opps-global-giving_svg__action-opps-global-giving_svg__st1{fill:#80A0B5}.action-opps-global-giving_svg__action-opps-global-giving_svg__st2{fill:#B1BA1E}.action-opps-global-giving_svg__action-opps-global-giving_svg__st3{fill:#FFD200}\n  ");

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\n    action-opps-eventbrite\n  ");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "action-opps-global-giving_svg__action-opps-global-giving_svg__st0",
  d: "M43.8,10.4c2.1-0.1,3.7-1.8,3.7-3.9c0-2.2-1.8-3.9-3.9-3.9c-2.1,0-3.8,1.6-3.9,3.7l-5.3-5.3L25,10.3l9.2,9.2 L25,28.7l5.5,5.5l18.6-18.6L43.8,10.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "action-opps-global-giving_svg__action-opps-global-giving_svg__st1",
  d: "M10.4,6.2c-0.1-2.1-1.8-3.7-3.9-3.7c-2.2,0-3.9,1.8-3.9,3.9c0,2.1,1.6,3.8,3.7,3.9l-5.3,5.3l9.4,9.4l9.2-9.2 l9.2,9.2l5.5-5.5L15.7,0.9L10.4,6.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "action-opps-global-giving_svg__action-opps-global-giving_svg__st2",
  d: "M6.2,39.6c-2.1,0.1-3.7,1.8-3.7,3.9c0,2.2,1.8,3.9,3.9,3.9c2.1,0,3.8-1.6,3.9-3.7l5.3,5.3l9.4-9.3l-9.2-9.2 l9.2-9.2l-5.5-5.5L1,34.3L6.2,39.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "action-opps-global-giving_svg__action-opps-global-giving_svg__st3",
  d: "M39.6,43.8c0.1,2.1,1.8,3.7,3.9,3.7c2.2,0,3.9-1.8,3.9-3.9c0-2.1-1.6-3.8-3.7-3.9l5.3-5.3L39.7,25l-9.2,9.2 L21.3,25l-5.5,5.5l18.6,18.6L39.6,43.8z"
}));

function SvgActionOppsGlobalGiving(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default SvgActionOppsGlobalGiving;